import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Fleet from './components/Fleet';
import About from './components/About';
import BookingEngine from './components/BookingEngine';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const payment = searchParams.get('payment');
    const reservationNumber = searchParams.get('reservationNumber');

    if (payment === 'success' && reservationNumber) {
      handlePayPalReturn(reservationNumber);
    } else if (payment === 'cancel' && reservationNumber) {
      alert('Pagamento cancelado. A sua reserva foi guardada e pode efetuar o pagamento posteriormente.');
      // Limpar parâmetros da URL
      setSearchParams({});
    }
  }, [searchParams, setSearchParams]);

  const handlePayPalReturn = async (reservationNumber: string) => {
    try {
      const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
      
      // Obter o orderId dos parâmetros da URL
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token'); // PayPal retorna o order ID como 'token'

      if (!token) {
        throw new Error('Order ID não encontrado');
      }

      console.log('🔄 Capturando pagamento PayPal...', token);

      // Capturar o pagamento
      const captureResponse = await fetch(`${supabaseUrl}/functions/v1/process-paypal-payment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          action: 'capture',
          orderId: token
        })
      });

      const captureResult = await captureResponse.json();

      if (captureResult.success) {
        console.log('✅ Pagamento capturado com sucesso!');
        
        // Mostrar mensagem de sucesso
        alert(`✅ Pagamento confirmado!\n\nReserva #${reservationNumber}\nValor: €${captureResult.amount}\n\nReceberá um email de confirmação em breve.`);
        
        // Limpar parâmetros da URL
        setSearchParams({});
        
        // Scroll para o topo
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        throw new Error(captureResult.error || 'Erro ao capturar pagamento');
      }
    } catch (error) {
      console.error('Erro ao processar retorno do PayPal:', error);
      alert(`Erro ao confirmar pagamento: ${error instanceof Error ? error.message : 'Erro desconhecido'}. Por favor, contacte-nos.`);
      setSearchParams({});
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <BookingEngine />
      <Services />
      <Fleet />
      <About />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}